import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import LegalLayout from "@/components/legal/LegalLayout";
import PolicyView from "@/components/legal/PolicyView";
import { BY_SLUG } from "../../legal/registry";

// Generic public policy page. `slug` selects the content module from the registry.
export default function PolicyPage({ slug }) {
  const policy = BY_SLUG[slug];
  useEffect(() => {
    if (policy) document.title = `${policy.title} · PRYMEBET`;
  }, [policy]);
  if (!policy) return <Navigate to="/legal" replace />;
  return (
    <LegalLayout policy={policy}>
      <PolicyView policy={policy} />
    </LegalLayout>
  );
}
